import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { Cancel01Icon } from '@hugeicons/core-free-icons';

function Exit(props) {
    const className = props.className;
    const fill = props.fill;
    const clickFunc = props.clickFunc;
    const size = props.size;
    
    return (
        <HugeiconsIcon
            icon={Cancel01Icon}
            className={className}
            onClick={() => clickFunc == null ? null : clickFunc()}
            size={size}
            color={fill}
        />
    )
};

export default Exit;